import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import api from "../lib/api";
import { toast } from "sonner";

export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash || "";
        const m = hash.match(/session_id=([^&]+)/);
        const sessionId = m?.[1];

        if (!sessionId) {
            navigate("/login", { replace: true });
            return;
        }

        (async () => {
            try {
                const { data } = await api.post("/auth/session", { session_id: sessionId });
                setUser(data.user);
                // Clear hash and route to webmail (or admin if admin)
                const dest = data.user?.role === "admin" ? "/admin" : "/webmail";
                window.history.replaceState({}, "", window.location.pathname);
                navigate(dest, { replace: true, state: { user: data.user } });
                toast.success(`Welcome, ${data.user.name}.`);
            } catch (e) {
                toast.error("Sign-in failed. Please try again.");
                navigate("/login", { replace: true });
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="min-h-[60vh] flex items-center justify-center">
            <div className="font-mono-cap text-xs text-slate-500">Securing session…</div>
        </div>
    );
}
